export const boolPropsToClassNames = (propsObj = {}) => {
  return Object.keys(propsObj)
    .reduce((acc, key) => {
      const value = propsObj[key];
      return [...acc, ...(value ? [key.toString()] : [])];
    }, [])
    .join(' ');
};

export const createShouldForwardProp = (excludedProps = []) => {
  return prop => !excludedProps.includes(prop);
};
